import type { ReportBlock } from '@/lib/types/report'
import { tableStyles } from '../primitives/tableStyles'

type Group = { title?: string; columns: string[]; rows: (string | number)[][] }

const NUMERIC = /^\s*[-−]?[\d.,eE+%\s]+\s*$/

function isNumericColumn(rows: (string | number)[][], i: number): boolean {
  const vals = rows.map((r) => String(r[i] ?? '').trim()).filter((v) => v.length > 0)
  return vals.length > 0 && vals.every((v) => NUMERIC.test(v))
}

export function RankedTable({ block }: { block: ReportBlock }) {
  const groups = (block.data.groups as Group[]) ?? []
  return (
    <div className="space-y-2">
      {groups.map((g, gi) => {
        const numeric = g.columns.map((_, i) => isNumericColumn(g.rows, i))
        return (
          <div key={gi}>
            {g.title && <p className={tableStyles.groupTitle}>{g.title}</p>}
            <table className={tableStyles.table}>
              <thead>
                <tr className={tableStyles.headRow}>
                  {g.columns.map((c, i) => (
                    <th key={c} className={numeric[i] ? tableStyles.thNum : tableStyles.th}>{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {g.rows.map((r, ri) => (
                  <tr key={ri} className={tableStyles.row}>
                    {r.map((c, ci) => (
                      <td key={ci} className={numeric[ci] ? tableStyles.cellNum : tableStyles.cell}>{String(c)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      })}
    </div>
  )
}
